import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import DynamicLegend from "../DynamicLegend/DynamicLegend";
import dataLegend from "../../dataLegend";
import styled from "styled-components";

const styles = theme => ({
	appBar: {
		position: "relative"
	},
	flex: {
		flex: 1
	},
	dialogSize: {
		[theme.breakpoints.up("sm")]: {
			width: "55vw",
			margin: '0 auto',
			top: "10vh",
			maxHeight: '75vh',
		}
	}
});

const Copyright = styled.div`
	font-size: 0.6em;
	bottom: 0.6em;
	margin: 0.5em auto;
`;

class MdDialog extends Component {
	render() {
		const {value, classes, closeMe, ...other} = this.props;
		return (
			<Dialog
				className={classes.dialogSize}
				fullScreen
				disableBackdropClick
				disableEscapeKeyDown
				{...other}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<Typography
							color="inherit"
							variant="h6"
							className={classes.flex}
						>
							Mieux comprendre la carte
						</Typography>
						<IconButton color="inherit" onClick={closeMe}>
							<CloseIcon/>
						</IconButton>
					</Toolbar>
				</AppBar>

				<DialogContent className={classes.flex}>
					{dataLegend.map(legend => (
						<DynamicLegend
							id={legend.id}
                            key={legend.title}
							title={legend.helpTitle}
							description={legend.description}
							color={legend.color}
							minLegendDescription={legend.minLegendDescription}
							maxLegendDescription={legend.maxLegendDescription}
							maxOpacity={legend.maxOpacity}/>
					))}
				</DialogContent>
				<Copyright>© CELESTE. Tous droits reservés</Copyright>
			</Dialog>
		);
	}
}

export default withStyles(styles)(MdDialog);
